export class AdCard {
  constructor(
    name,
    length,
    frequency_per_route,
    cm,
    ts,
    sp,
    adCardBalance,
    createdDate,
    startDate,
    endDate
  ) {
    this.name = name;
    this.length = length;
    this.frequency_per_route = frequency_per_route;
    this.list_of_frequency = new Map();
    this.cm = cm;
    this.ts = ts;
    this.sp = sp;
    this.adCardBalance = adCardBalance;
    this.refund = 0;
    this.amountPaid = adCardBalance;
    this.created_date = createdDate;
    this.start_date = startDate;
    this.end_date = endDate;
    this.sda = 0;
    this.aalds = new Map();
    this.tascpd = [];
    this.astcpd = [];
    this.active = false;
    this.status = 0;
    this.readyToComplete = false;
    this.systemAccountId = "";
    this.businessId = "";
    this.adAudioId = "";
    this.totalNumberOfAdsServed = 0;
    this.totalServedAmount = 0;
  }
}
export class RouteAverage {
  constructor(
    cm,
    ts,
    sp,
    totalrouteAmount,
    averageAdBrake,
    rfstpd,
    scstpd,
    scstppd
  ) {
    this.cm = cm;
    this.ts = ts;
    this.sp = sp;
    this.totalAmountOfRoute = totalrouteAmount;
    this.averageAdBrake = averageAdBrake;
    this.rfstpd = rfstpd;
    this.scstpd = scstpd;
    this.scstppd = scstppd;
  }
}
class AdcardAmount {
  constructor(name, serveTime) {
    this.name = name;
    this.uaaa = 0;
    this.serveTime = serveTime;
    this.aata = new Map();
    this.percents = new Map();
    this.relativeScstppd = new Map();
  }
}
class ASTCPD {
  constructor(trip, date, value) {
    this.trip = trip;
    this.date = date;
    this.value = value;
  }
}
class TASCPD {
  constructor(date, value) {
    this.date = date;
    this.value = value;
  }
}
export class AdSchedule {
  constructor(date, cm, ts, sp, aastd, aalst) {
    this.date = date;
    this.cm = cm;
    this.ts = ts;
    this.sp = sp;
    this.aastd = aastd;
    this.aalst = aalst;
  }
}
// class SetupTotal {
//   constructor(trip, totalAdspot) {
//     this.trip = trip;
//     this.totalAdspot = totalAdspot;
//   }
// }
class CurrentSchedule {
  constructor(date) {
    this.date = date;
    this.cm = [];
    this.ts = [];
    this.sp = [];
    this.alsts = [];
    this.aastds = [];
  }
}
// this has margin of errors created when there are a lot of
// setups in one Ad card which create rounding errors
// TESTED
function assignAATA(adCardamounts) {
  for (let i = 0; i < adCardamounts.length; i++) {
    let totalScstppd = 0;
    adCardamounts[i].percents.forEach((value) => {
      totalScstppd += value[0];
    });
    adCardamounts[i].percents.forEach((value, key) => {
      let relativeScstppd = value[0] / totalScstppd;
      let aata = relativeScstppd * value[1] * value[2];
      aata = Math.round(aata);
      adCardamounts[i].aata.set(key, aata);
      adCardamounts[i].uaaa += aata;
      adCardamounts[i].relativeScstppd.set(key, relativeScstppd);
    });
  }
  return adCardamounts;
}
// little bit different to document as this accounts for relative percentage
// when it comes to scstppd
// list of ad cards retrived for this function must be active
// TESTED
// function adCardServeAmounts(routeAverages, listOfAdCards) {
//   let adcardamounts = [];
//   for (let i = 0; i < listOfAdCards.length; i++) {
//     var one_day = 1000 * 60 * 60 * 24;
//     let newStartDate = new Date();
//     newStartDate.setTime(listOfAdCards[i].start_date.getTime());
//     let currentDate = new Date();
//     let day = currentDate.getDate();
//     day -= 1;
//     currentDate.setDate(day);
//     let startCurrentDifference =
//       listOfAdCards[i].start_date.getTime() - currentDate.getTime();
//     startCurrentDifference = startCurrentDifference / one_day;
//     startCurrentDifference = Math.round(startCurrentDifference);
//     if (startCurrentDifference < 0) {
//       newStartDate.setTime(currentDate.getTime());
//       let day = newStartDate.getDate();
//       day += 1;
//       newStartDate.setDate(day);
//     }
//     for (let j = 0; j < listOfAdCards[i].cm.length; j++) {
//       for (let k = 0; k < listOfAdCards[i].ts.length; k++) {
//         for (let l = 0; l < listOfAdCards[i].sp.length; l++) {
//           for (let m = 0; m < routeAverages.length; m++) {
//             if (
//               routeAverages[m].cm ===  listOfAdCards[i].cm[j] &&
//               routeAverages[m].ts ===  listOfAdCards[i].ts[k] &&
//               routeAverages[m].sp ===  listOfAdCards[i].sp[l]
//             ) {
//               let exist = false;
//               let index = 0;
//               for (let n = 0; n < adcardamounts.length; n++) {
//                 if (listOfAdCards[i].name ===  adcardamounts[n].name) {
//                   index = n;
//                   exist = true;
//                   break;
//                 }
//               }
//               if (exist ===  false) {
//                 let difference =
//                   listOfAdCards[i].end_date.getTime() - newStartDate.getTime();
//                 difference = difference / one_day;
//                 difference = Math.round(difference);
//                 let setupFrequency = listOfAdCards[i].list_of_frequency.get(
//                   listOfAdCards[i].cm[j] +
//                     listOfAdCards[i].ts[k] +
//                     listOfAdCards[i].sp[l]
//                 );
//                 let cardAmount = new AdcardAmount(
//                   listOfAdCards[i].name,
//                   difference
//                 );
//                 if (setupFrequency != null) {
//                   cardAmount.percents.set(
//                     listOfAdCards[i].cm[j] +
//                       listOfAdCards[i].ts[k] +
//                       listOfAdCards[i].sp[l],
//                     [
//                       routeAverages[m].scstppd / 100,
//                       listOfAdCards[i].length,
//                       setupFrequency[0],
//                     ]
//                   );
//                   adcardamounts.push(cardAmount);
//                 }
//               } else {
//                 let setupFrequency = listOfAdCards[i].list_of_frequency.get(
//                   listOfAdCards[i].cm[j] +
//                     listOfAdCards[i].ts[k] +
//                     listOfAdCards[i].sp[l]
//                 );
//                 if (setupFrequency != null) {
//                   adcardamounts[index].percents.set(
//                     listOfAdCards[i].cm[j] +
//                       listOfAdCards[i].ts[k] +
//                       listOfAdCards[i].sp[l],
//                     [
//                       routeAverages[m].scstppd / 100,
//                       listOfAdCards[i].length,
//                       setupFrequency[0],
//                     ]
//                   );
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
//   }
//   adcardamounts = assignAATA(adcardamounts);
//   return adcardamounts;
// }
// TESTED
export function singlefrequencyAssigner(valueMapVar, card) {
  //console.log("ValuMap: " + valueMapVar.size + " card: " + card);
  for (let j = 0; j < card.cm.length; j++) {
    for (let k = 0; k < card.ts.length; k++) {
      for (let l = 0; l < card.sp.length; l++) {
        // the pluses are useful because when we assign the
        // cm, ts and sp value we add those letters
        let cPercent = valueMapVar.get(card.cm[j] + "c");
        let tPercent = valueMapVar.get(card.ts[k] + "t");
        let superPathPrice = valueMapVar.get(card.sp[l] + "s");
        if (cPercent != null && tPercent != null && superPathPrice != null) {
          let cDeductable = cPercent * superPathPrice;
          cDeductable /= 100;
          let tDeductable = tPercent * superPathPrice;
          tDeductable /= 100;
          let finalValue = superPathPrice - cDeductable - tDeductable;
          finalValue *= card.length;
          let specificFrequency = card.adCardBalance / finalValue;
          specificFrequency = Math.floor(specificFrequency);
          // just add the strings together so we can use it as a key
          card.list_of_frequency.set(card.cm[j] + card.ts[k] + card.sp[l], [
            specificFrequency,
            parseFloat(finalValue.toFixed(3)),
          ]);
          //console.log("spf: " + specificFrequency);
        }
      }
    }
  }

  return card;
}
// let valueMap = new Map();
// valueMap.set("c1" + "c", 0);
// valueMap.set("c2" + "c", 20);
// valueMap.set("t1" + "t", 10);
// valueMap.set("t2" + "t", 0);
// // the value is profit per length (30sec) below
// valueMap.set("s1" + "s", 0.75);
// valueMap.set("s2" + "s", 0.85);
// // proves scheduleIdentifier
// let newAdCard = new AdCard(
//   "d",
//   1,
//   1,
//   ["c1", "c2"],
//   ["t1", "t2"],
//   ["s1"],
//   250,
//   new Date(2021, 2, 15),
//   new Date(2021, 5, 10),
//   new Date(2021, 9, 16)
// );
// newAdCard = frequencyAssigner(valueMap, newAdCard);
// DAGIM CODE
// You can get the start date by retriving the oldest ad schedule uploaded since
// there are no Ad schedules for date that cant be served
// when combining target variables to produce setup we have to be sure the order
// is cm => ts => sp
// have to give rough estimate and assign endDate to the Ad card for this function
// to work
// we have to make sure there is atleast one setup of the Ad card
// that has a corresponding routeAverage from the latest route Averages (look
// to create Ad schedule for ways to retrive the latest route average)
// REMARK: scheduleIdentifier is not affected by current date like asip
// like if you give it date earlier than current date and Ad schedules are
// for dates after the current date it will perform the algorithm like all
// the dates are free. (This information is only useful to clear up confusion
// that might happen when you run the code without updating the dates of the
// ad card that is used for this algorithm and gives you dates that already
// passed)
export function scheduleIdentifierOld(
  routeAverages,
  adSchedules,
  adCard,
  startDate
) {
  // take to finish serving the Ad card according to our calculation
  let adcardamounts = [];
  var one_day = 1000 * 60 * 60 * 24;
  let newStartDate = new Date();
  newStartDate.setTime(adCard.start_date.getTime());
  let cms = [];
  let tss = [];
  let sps = [];
  let alsts = [];
  let astcpdList = [];
  let tascpdList = [];
  let startCurrentDifference =
    adCard.start_date.getTime() - startDate.getTime();
  startCurrentDifference = startCurrentDifference / one_day;
  startCurrentDifference = Math.round(startCurrentDifference);
  if (startCurrentDifference < 0) {
    newStartDate.setTime(startDate.getTime());
  }
  for (let j = 0; j < adCard.cm.length; j++) {
    for (let k = 0; k < adCard.ts.length; k++) {
      for (let l = 0; l < adCard.sp.length; l++) {
        let cm = adCard.cm[j];
        let ts = adCard.ts[k];
        let sp = adCard.sp[l];
        for (let m = 0; m < routeAverages.length; m++) {
          if (
            routeAverages[m].cm === adCard.cm[j] &&
            routeAverages[m].ts === adCard.ts[k] &&
            routeAverages[m].sp === adCard.sp[l]
          ) {
            cms.push(cm);
            tss.push(ts);
            sps.push(sp);
            alsts.push(routeAverages[m].scstpd);
            let exist = false;
            let index = 0;
            for (let n = 0; n < adcardamounts.length; n++) {
              if (adCard.name === adcardamounts[n].name) {
                index = n;
                exist = true;
                break;
              }
            }
            if (exist === false) {
              let difference =
                adCard.end_date.getTime() - newStartDate.getTime();
              difference = difference / one_day;
              difference = Math.round(difference);
              console.log(
                "Card Amount Setup : " +
                  adCard.cm[j] +
                  " : " +
                  adCard.ts[k] +
                  " : " +
                  adCard.sp[l]
              );
              let setupFrequency = adCard.list_of_frequency.get(
                adCard.cm[j] + adCard.ts[k] + adCard.sp[l]
              );
              let cardAmount = new AdcardAmount(adCard.name, difference);
              if (setupFrequency != null) {
                cardAmount.percents.set(
                  adCard.cm[j] + adCard.ts[k] + adCard.sp[l],
                  [
                    routeAverages[m].scstppd / 100,
                    adCard.length,
                    setupFrequency[0],
                  ]
                );
                console.log("Card Amount");
                console.log(cardAmount);
                adcardamounts.push(cardAmount);
              }
            } else {
              let setupFrequency = adCard.list_of_frequency.get(
                adCard.cm[j] + adCard.ts[k] + adCard.sp[l]
              );
              if (setupFrequency != null) {
                adcardamounts[index].percents.set(
                  adCard.cm[j] + adCard.ts[k] + adCard.sp[l],
                  [
                    routeAverages[m].scstppd / 100,
                    adCard.length,
                    setupFrequency[0],
                  ]
                );
              }
            }
          }
        }
      }
    }
  }
  let currentSchedules = [];
  adcardamounts = assignAATA(adcardamounts);
  // for(let i=0;i<adcardamounts.length;i++){
  // adcardamounts[i].aata.forEach((value:number,key:string)=>{
  //     console.log("key: "+key+" value: "+value);
  // })
  // console.log("card: "+adcardamounts[i].name+" value: "+adcardamounts[i].uaaa)
  // }
  let difference = adCard.end_date.getTime() - newStartDate.getTime();
  difference /= one_day;
  difference = Math.round(difference);
  // console.log("start: "+newStartDate.toDateString()+" end: "+adCard.end_date.toDateString()
  // +" diff: "+difference);
  for (let i = 0; i <= difference; i++) {
    let day = newStartDate.getTime();
    let addition = i * one_day;
    day += addition;
    let date = new Date(day);
    let currentSchedul = new CurrentSchedule(date);
    let newCms = [];
    let newTss = [];
    let newSps = [];
    let newAlsts = [];
    // used cms length because tss, sps and alsts
    for (let l = 0; l < cms.length; l++) {
      let exist = false;
      for (let j = 0; j < adSchedules.length; j++) {
        let adSetup = cms[l] + tss[l] + sps[l];
        let setup = adSchedules[j].cm + adSchedules[j].ts + adSchedules[j].sp;
        if (
          adSchedules[j].date.toDateString() === date.toDateString() &&
          setup === adSetup
        ) {
          newCms.push(cms[l]);
          newTss.push(tss[l]);
          newSps.push(sps[l]);
          newAlsts.push(adSchedules[j].aalst);
          exist = true;
          break;
        }
      }
      if (exist === false) {
        newCms.push(cms[l]);
        newTss.push(tss[l]);
        newSps.push(sps[l]);
        newAlsts.push(alsts[l]);
      }
    }
    currentSchedul.cm = newCms;
    currentSchedul.ts = newTss;
    currentSchedul.sp = newSps;
    currentSchedul.alsts = newAlsts;
    currentSchedules.push(currentSchedul);
  }
  // console.log("cs leng: "+currentSchedules.length);
  // for(let t=0;t<currentSchedules.length;t++){
  //     console.log("date : "+currentSchedules[t].date);
  //     for(let b=0;b<currentSchedules[t].cm.length;b++){
  //         console.log("Setup: "+currentSchedules[t].cm[b]+currentSchedules[t]
  //         .ts[b]+currentSchedules[t].sp[b]+" aalst: "+currentSchedules[t].alsts[b]);
  //     }
  // }
  let newAdSchedules = [];
  let maximumWait = 0;
  let firstTime = true;
  adcardamounts[0].aata.forEach((value, key) => {
    let temp = value;
    let daysCounter = 0;
    let canBreak = false;
    for (let m = 0; m <= difference; m++) {
      let day = newStartDate.getTime();
      let addition = m * one_day;
      day += addition;
      let date = new Date(day);
      for (let n = 0; n < currentSchedules.length; n++) {
        if (currentSchedules[n].date.toDateString() === date.toDateString()) {
          // console.log("match loop: "+date+" end: "+currentSchedules[n].date);
          for (let p = 0; p < currentSchedules[n].cm.length; p++) {
            let setup =
              currentSchedules[n].cm[p] +
              currentSchedules[n].ts[p] +
              currentSchedules[n].sp[p];
            if (key === setup) {
              let alst = 0,
                aastd = 0;
              // console.log("keyINt: "+key);
              if (temp >= currentSchedules[n].alsts[p]) {
                temp -= currentSchedules[n].alsts[p];
                aastd = currentSchedules[n].alsts[p];
                daysCounter++;
                newAdSchedules.push(
                  new AdSchedule(
                    date,
                    currentSchedules[n].cm[p],
                    currentSchedules[n].ts[p],
                    currentSchedules[n].sp[p],
                    aastd,
                    alst
                  )
                );
                astcpdList.push(new ASTCPD(setup, date, aastd));
                let tascpdExist = false;
                let existIndex = 0;
                for (let tindex = 0; tindex < tascpdList.length; tindex++) {
                  if (
                    tascpdList[tindex].date.toDateString() ===
                    date.toDateString()
                  ) {
                    tascpdExist = true;
                    existIndex = tindex;
                  }
                }
                if (tascpdExist) {
                  tascpdList[existIndex].value += aastd;
                } else {
                  tascpdList.push(new TASCPD(date, aastd));
                }
                break;
              } else {
                alst = currentSchedules[n].alsts[p] - temp;
                aastd = temp;
                daysCounter++;
                newAdSchedules.push(
                  new AdSchedule(
                    date,
                    currentSchedules[n].cm[p],
                    currentSchedules[n].ts[p],
                    currentSchedules[n].sp[p],
                    aastd,
                    alst
                  )
                );
                astcpdList.push(new ASTCPD(setup, date, aastd));
                let tascpdExist = false;
                let existIndex = 0;
                for (let tindex = 0; tindex < tascpdList.length; tindex++) {
                  if (
                    tascpdList[tindex].date.toDateString() ===
                    date.toDateString()
                  ) {
                    tascpdExist = true;
                    existIndex = tindex;
                  }
                }
                if (tascpdExist) {
                  tascpdList[existIndex].value += aastd;
                } else {
                  tascpdList.push(new TASCPD(date, aastd));
                }
                // console.log("time for break: "+temp+" scstpd: "+currentSchedules[n].alsts[p]
                // +" date: "+date);
                canBreak = true;
                break;
              }
            }
          }
          if (canBreak === true) {
            break;
          }
        }
      }
      if (canBreak === true) {
        break;
      }
    }
    if (firstTime === true || daysCounter > maximumWait) {
      maximumWait = daysCounter;
      firstTime = false;
    }
  });
  // In the future we can give pridiction about serve amount
  // of specific trip and date by just looking in the astcpdList
  // of the Ad card (but this are just capability for dates) but
  // for now thats TMI (Too much info) so we give them the
  // serve amount of specific dates which is tascpdList but
  // we will assign the astcpdList so we can use it when we
  // decide in the future
  adCard.tascpd = tascpdList;
  adCard.astcpd = astcpdList;
  adCard.sda = maximumWait;
  return [maximumWait, newAdSchedules, adCard];
}

export function scheduleIdentifier(
  routeAverages,
  adSchedules,
  adCard,
  startDate,
  maximumAdSpotPerAdBreak
) {
  //console.log("NeWAdCar: " + maximumAdSpotPerAdBreak);
  // console.log("ROUTE AVERAGES");
  // console.log(routeAverages);
  // console.log(adCard);
  // it will approximately take to finish serving the Ad card according to our calculation
  // let adcardamounts:AdcardAmount[]=[];
  var one_day = 1000 * 60 * 60 * 24;
  let newStartDate = new Date();
  newStartDate.setTime(adCard.start_date.getTime());
  let cms = [];
  let tss = [];
  let sps = [];
  let alsts = [];
  let averageAdBrakes = [];
  let astcpdList = [];
  let tascpdList = [];
  let originalBalance = adCard.adCardBalance;
  let startCurrentDifference =
    adCard.start_date.getTime() - startDate.getTime();
  startCurrentDifference = startCurrentDifference / one_day;
  startCurrentDifference = Math.round(startCurrentDifference);
  if (startCurrentDifference < 0) {
    newStartDate.setTime(startDate.getTime());
  }
  for (let j = 0; j < adCard.cm.length; j++) {
    for (let k = 0; k < adCard.ts.length; k++) {
      for (let l = 0; l < adCard.sp.length; l++) {
        // let cm=adCard.cm[j]
        // let ts=adCard.ts[k]
        // let sp=adCard.sp[l];
        for (let m = 0; m < routeAverages.length; m++) {
          if (
            routeAverages[m].cm === adCard.cm[j] &&
            routeAverages[m].ts === adCard.ts[k] &&
            routeAverages[m].sp === adCard.sp[l]
          ) {
            cms.push(adCard.cm[j]);
            tss.push(adCard.ts[k]);
            sps.push(adCard.sp[l]);
            alsts.push(routeAverages[m].scstpd);
            averageAdBrakes.push(routeAverages[m].averageAdBrake);
            break;
          }
        }
      }
    }
  }
  let adScheduleMap = new Map();
  for (let index = 0; index < adSchedules.length; index++) {
    const element = adSchedules[index];
    let setup = element.cm + element.ts + element.sp;
    adScheduleMap.set(setup + element.date.toDateString(), element);
  }
  // console.log("AdScheduleMap");
  // console.log(adScheduleMap);
  let currentSchedules = [];
  let difference = adCard.end_date.getTime() - newStartDate.getTime();
  difference /= one_day;
  difference = Math.round(difference);
  // console.log(
  //   "11 start: " +
  //     newStartDate.toDateString() +
  //     " end:" +
  //     adCard.end_date.toDateString() +
  //     " diff: " +
  //     difference
  // );
  for (let i = 0; i <= difference; i++) {
    let day = newStartDate.getTime();
    let addition = i * one_day;
    day += addition;
    let date = new Date(day);
    let currentSchedul = new CurrentSchedule(date);
    // let newCms:string[]=[];
    // let newTss:string[]=[];
    // let newSps:string[]=[];
    let newAlsts = [];
    let newAastd = [];
    // used cms length because tss, sps and alsts have the same length
    for (let l = 0; l < cms.length; l++) {
      let exist = false;
      // NEW By Abrham
      let adSetup = cms[l] + tss[l] + sps[l];
      let key = adSetup + date.toDateString();
      if (adScheduleMap.has(key)) {
        let identifiedAdSchedule = adScheduleMap.get(key);
        // console.log("A: " + key);
        // console.log(identifiedAdSchedule);
        newAlsts.push(identifiedAdSchedule.aalst);
        newAastd.push(identifiedAdSchedule.aastd);
        exist = true;
      }
      //
      // for (let j = 0; j < adSchedules.length; j++) {
      //   let adSetup = cms[l] + tss[l] + sps[l];
      //   let setup = adSchedules[j].cm + adSchedules[j].ts + adSchedules[j].sp;
      //   if (
      //     adSchedules[j].date.toDateString() === date.toDateString() &&
      //     setup === adSetup
      //   ) {
      //     // newCms.push(cms[l]);
      //     // newTss.push(tss[l]);
      //     // newSps.push(sps[l]);
      //     newAlsts.push(adSchedules[j].aalst);
      //     newAastd.push(adSchedules[j].aastd);
      //     exist = true;
      //     break;
      //   }
      // }
      if (exist === false) {
        //  newCms.push(cms[l]);
        //  newTss.push(tss[l]);
        //  newSps.push(sps[l]);
        newAlsts.push(alsts[l]);
        newAastd.push(0);
      }
    }
    // currentSchedul.cm=newCms;
    // currentSchedul.ts=newTss;
    // currentSchedul.sp=newSps;
    currentSchedul.cm = cms;
    currentSchedul.ts = tss;
    currentSchedul.sp = sps;
    currentSchedul.alsts = newAlsts;
    currentSchedul.aastds = newAastd;
    currentSchedul.averageAdBrakes = averageAdBrakes;
    currentSchedules.push(currentSchedul);
  }
  // console.log("22 cs leng: " + currentSchedules.length + " " + difference);
  // for(let t=0;t<currentSchedules.length;t++){
  //   console.log("date : "+currentSchedules[t].date);
  //   for(let b=0;b<currentSchedules[t].cm.length;b++){
  //     console.log("Setup: "+currentSchedules[t].cm[b]+currentSchedules[t]
  //     .ts[b]+currentSchedules[t].sp[b]+" aalst: "+currentSchedules[t].alsts[b]);
  //   }
  // }
  let sda = 0;
  let newAdSchedules = [];
  for (let i = 0; i <= difference; i++) {
    let day = newStartDate.getTime();
    let addition = i * one_day;
    day += addition;
    let date = new Date(day);
    let n = 0;
    let canBreak = true;
    for (let m = 0; m < currentSchedules.length; m++) {
      if (currentSchedules[m].date.toDateString() === date.toDateString()) {
        n = m;
        break;
      }
    }
    for (let [key, value] of adCard.list_of_frequency) {
      let pricePerAdSpot = value[1] / adCard.length;
      let temp = Math.floor(adCard.adCardBalance / pricePerAdSpot);
      //console.log("Temp: " + temp + " " + currentSchedules[n].cm.length);
      if (temp > 0) {
        canBreak = false;
        for (let p = 0; p < currentSchedules[n].cm.length; p++) {
          let setup =
            currentSchedules[n].cm[p] +
            currentSchedules[n].ts[p] +
            currentSchedules[n].sp[p];
          let setupForWrite =
            currentSchedules[n].cm[p] +
            "-" +
            currentSchedules[n].ts[p] +
            "-" +
            currentSchedules[n].sp[p];
          //console.log("key: " + key + " " + setup);
          if (key === setup) {
            let alst = 0,
              aastd = 0;
            // console.log("keyINt: "+key)
            let scstpd =
              currentSchedules[n].aastds[p] + currentSchedules[n].alsts[p];
            let serveShareLeft = (currentSchedules[n].alsts[p] * 100) / scstpd;
            let lengthPerc =
              (adCard.length * 100) /
              (currentSchedules[n].averageAdBrakes[p] *
                maximumAdSpotPerAdBreak);
            let newFreqPerRoute = 1;
            if (
              adCard.frequency_per_route >
              currentSchedules[n].averageAdBrakes[p]
            ) {
              newFreqPerRoute = currentSchedules[n].averageAdBrakes[p];
            }
            let percOutOf100 =
              (newFreqPerRoute * adCard.length * 100) /
              (currentSchedules[n].averageAdBrakes[p] *
                maximumAdSpotPerAdBreak);
            // console.log(
            //   "PercOut: " + percOutOf100 + " " + maximumAdSpotPerAdBreak
            // );
            if (percOutOf100 >= serveShareLeft) {
              if (lengthPerc <= serveShareLeft) {
                let freqLeft = Math.floor(serveShareLeft / lengthPerc);
                percOutOf100 = lengthPerc * freqLeft;
              } else {
                percOutOf100 = 0;
              }
            }
            // console.log(
            //   "Serve share : " +
            //     serveShareLeft +
            //     " percOutOf100 " +
            //     percOutOf100.toFixed(2) +
            //     " nfr " +
            //     newFreqPerRoute +
            //     " " +
            //     adCard.length +
            //     " " +
            //     currentSchedules[n].averageAdBrakes[p]
            // );
            // console.log(
            //   "scstpd: " +
            //     scstpd +
            //     " cdate " +
            //     currentSchedules[n].date +
            //     " date: " +
            //     date
            // );
            aastd = Math.round((percOutOf100 / 100) * scstpd);
            if (temp > aastd) {
              alst = currentSchedules[n].alsts[p] - aastd;
              if (alst < 0) {
                alst = 0;
              }
              // temp-=aastd;
              let balanceDeduct = aastd * pricePerAdSpot;
              adCard.adCardBalance -= balanceDeduct;
              newAdSchedules.push(
                new AdSchedule(
                  date,
                  currentSchedules[n].cm[p],
                  currentSchedules[n].ts[p],
                  currentSchedules[n].sp[p],
                  currentSchedules[n].aastds[p] + aastd,
                  alst
                )
              );
              astcpdList.push(new ASTCPD(setupForWrite, date, aastd));
              let tascpdExist = false;
              let existIndex = 0;
              for (let tindex = 0; tindex < tascpdList.length; tindex++) {
                if (
                  tascpdList[tindex].date.toDateString() === date.toDateString()
                ) {
                  tascpdExist = true;
                  existIndex = tindex;
                }
              }
              if (tascpdExist) {
                tascpdList[existIndex].value += aastd;
              } else {
                tascpdList.push(new TASCPD(date, aastd));
              }
              break;
            } else {
              alst = currentSchedules[n].alsts[p] - temp;
              if (alst < 0) {
                alst = 0;
              }
              aastd = temp;
              let balanceDeduct = aastd * pricePerAdSpot;
              adCard.adCardBalance -= balanceDeduct;
              newAdSchedules.push(
                new AdSchedule(
                  date,
                  currentSchedules[n].cm[p],
                  currentSchedules[n].ts[p],
                  currentSchedules[n].sp[p],
                  currentSchedules[n].aastds[p] + aastd,
                  alst
                )
              );
              astcpdList.push(new ASTCPD(setupForWrite, date, aastd));
              let tascpdExist = false;
              let existIndex = 0;
              for (let tindex = 0; tindex < tascpdList.length; tindex++) {
                if (
                  tascpdList[tindex].date.toDateString() === date.toDateString()
                ) {
                  tascpdExist = true;
                  existIndex = tindex;
                }
              }
              if (tascpdExist) {
                tascpdList[existIndex].value += aastd;
              } else {
                tascpdList.push(new TASCPD(date, aastd));
              }
              break;
            }
          }
        }
      }
    }
    if (canBreak) {
      break;
    }
    sda = i;
  }
  // console.log(
  //   "33 ListFreq: " +
  //     adCard.list_of_frequency.size +
  //     " " +
  //     newAdSchedules.length
  // );
  // console.log(adCard);
  // because i starts from 0 we need to add 1
  // to make it a length
  sda += 1;
  adCard.adCardBalance = originalBalance;
  // console.log("new "+newAdSchedules.length);
  newAdSchedules = combineSchedules(adSchedules, newAdSchedules);
  //console.log("44 Tascpd: " + tascpdList.length + " " + astcpdList.length);
  // In the future we can give pridiction about serve amount
  // of specific trip and date by just looking in the astcpdList
  // of the Ad card but
  // for now thats TMI (Too much info) so we give them the
  // serve amount of specific dates which is tascpdList but
  // we will assign the astcpdList so we can use it when we
  // decide in the future
  adCard.tascpd = tascpdList;
  adCard.astcpd = astcpdList;
  return [sda, newAdSchedules, adCard];
}

function combineSchedules(oldSchedules, newSchedules) {
  for (let i = 0; i < oldSchedules.length; i++) {
    if (newSchedules.length === 0) {
      break;
    }
    let oldSetup = oldSchedules[i].cm + oldSchedules[i].ts + oldSchedules[i].sp;
    for (let j = 0; j < newSchedules.length; j++) {
      let newSetup =
        newSchedules[j].cm + newSchedules[j].ts + newSchedules[j].sp;
      if (
        oldSchedules[i].date.toDateString() ===
          newSchedules[j].date.toDateString() &&
        oldSetup === newSetup
      ) {
        oldSchedules[i].aalst = newSchedules[j].aalst;
        oldSchedules[i].aastd = newSchedules[j].aastd;
        newSchedules.splice(j, 1);
        break;
      }
    }
  }
  return oldSchedules.concat(newSchedules);
}

export function adSetupCreation(adCard, setupLimitPerDoc) {
  let sp = adCard.sp;
  let spLimit = 1;
  if (adCard.cm.length * adCard.ts.length < setupLimitPerDoc) {
    spLimit = Math.floor(
      setupLimitPerDoc / (adCard.cm.length * adCard.ts.length)
    );
  }
  console.log("spLimit: " + spLimit);
  let sps = chunk(sp, spLimit);
  let adCards = [];
  for (let i = 0; i < sps.length; i++) {
    adCards.push(
      new AdCard(
        adCard.name,
        adCard.length,
        adCard.frequency_per_route,
        adCard.cm,
        adCard.ts,
        sps[i],
        adCard.adCardBalance,
        adCard.created_date,
        adCard.start_date,
        adCard.end_date
      )
    );
  }
  return adCards;
}

export function chunk(arr, len) {
  var chunks = [],
    i = 0,
    n = arr.length;
  while (i < n) {
    chunks.push(arr.slice(i, (i += len)));
  }
  console.log("CHUNKS LENGTH: " + chunks.length);
  console.log(chunks);
  return chunks;
}

export function getidfromkey(arr) {
  try {
    const idarray = [];
    arr.forEach((et) => {
      const spliced = et.split(" :::: ");
      idarray.push(spliced[1]);
    });
    return idarray;
  } catch (e) {
    return [];
  }
}

export function getidfromkeystr(strr) {
  try {
    const spliced = strr.split(" :::: ");
    return spliced[1];
  } catch (e) {
    return "!@#$%a";
  }
}

export function cartesian(...args) {
  var r = [],
    max = args.length - 1;
  function helper(arr, i) {
    for (var j = 0, l = args[i].length; j < l; j++) {
      var a = arr.slice(0); // clone arr
      a.push(args[i][j]);
      if (i === max) r.push(a);
      else helper(a, i + 1);
    }
  }
  helper([], 0);
  return r;
}
